import React from 'react';

import { MotorcycleVinControlProps } from './MotorcycleVinControl.interfaces';
import VinControl from '../VinControl';

export default function MotorcycleVinControl(props: MotorcycleVinControlProps) {
  return <VinControl {...props} isMotor />;
}
